import React from 'react';
import { Waves, Sparkles, Home as HomeIcon } from 'lucide-react';

const ICONS = [Waves, Sparkles, HomeIcon];

/**
 * Renders the 3-card "Project Styles" grid for a city page.
 * Each card pulls a pool image deterministically from the local
 * pool-water photo set using the city slug as a seed.
 */
const ProjectStylesSection = ({ city, poolImages }) => (
  <section className="bg-[#f3f6fb] py-14">
    <div className="max-w-[1280px] mx-auto px-5">
      <div className="text-center mb-10">
        <h2 className="font-serif text-3xl md:text-4xl text-[#0b1e4d] font-bold">
          Project Styles We Build in {city.name}
        </h2>
        <p className="text-gray-600 mt-2 text-[15px]">
          Signature designs crafted for the {city.name} lifestyle
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {city.styles.map((style, idx) => {
          const Icon = ICONS[idx % ICONS.length];
          const img = poolImages[(idx * 3 + city.slug.length) % poolImages.length];
          return (
            <article
              key={style}
              className="bg-white rounded-sm overflow-hidden border border-gray-200 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={img}
                  alt={`${style} — custom pool design in ${city.name}, Florida`}
                  loading="lazy"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-9 h-9 rounded-full bg-[#1e4fa3] text-white flex items-center justify-center">
                    <Icon className="w-4 h-4" />
                  </div>
                  <span className="text-[11px] font-bold tracking-wider uppercase text-[#1e4fa3]">
                    Style {idx + 1}
                  </span>
                </div>
                <h3 className="font-serif text-xl text-[#0b1e4d] font-bold leading-tight">
                  {style}
                </h3>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  </section>
);

export default ProjectStylesSection;
